import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5583e994"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/opt/build/repo/components/Logo.vue').default,ScMainNav: require('/opt/build/repo/node_modules/@evince/site/lib/packages/MainNav.vue').default,ScLangSwitcher: require('/opt/build/repo/node_modules/@evince/site/lib/packages/LangSwitcher.vue').default,SearchInput: require('/opt/build/repo/components/SearchInput.vue').default,UserSession: require('/opt/build/repo/components/UserSession.vue').default,EshopCartToggle: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartToggle.vue').default,ScEmailLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/EmailLink.vue').default,ScPhoneLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/PhoneLink.vue').default,ScViberLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/ViberLink.vue').default,ScWhatsappLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/WhatsappLink.vue').default,ScMobileMenu: require('/opt/build/repo/node_modules/@evince/site/lib/packages/MobileMenu.vue').default})
